import { Address } from "@shared/types";

const addressFormatTemplates: { [key: string]: (string | undefined)[] } = {
  US: ["{firstName} {lastName}", "{company}", "{address1}", "{address2}", "{city}, {province} {zip}", "{country}"],
  GB: ["{firstName} {lastName}", "{company}", "{address1}", "{address2}", "{city}", "{province}", "{zip}", "{country}"],
  DE: ["{firstName} {lastName}", "{company}", "{address1}", "{address2}", "{zip} {city}", "{province}", "{country}"],
};

const formatAddress = (template: (string | undefined)[], address: Address): string[] => {
  return template
    .map((line) => {
      return line
        ?.replace("{firstName}", address.firstName ?? address.name ?? "")
        .replace("{lastName}", address.lastName ?? "")
        .replace("{company}", address.company ?? "")
        .replace("{address1}", address.address1 ?? "")
        .replace("{address2}", address.address2 ?? "")
        .replace("{city}", address.city ?? "")
        .replace("{province}", address.province ?? "")
        .replace("{zip}", address.zip ?? "")
        .replace("{country}", address.country ?? "");
    })
    .filter((line): line is string => Boolean(line?.trim())); // Filter out empty or whitespace-only lines
};

export const calculateAddressLines = (address: Address): string[] => {
  const country = (address.countryCode ?? address.country)?.toUpperCase();
  const defaultTemplate: (string | undefined)[] = addressFormatTemplates["US"] ?? [];
  const countryTemplate = country ? addressFormatTemplates[country] : undefined;
  const addressTemplate = Array.isArray(countryTemplate) ? countryTemplate : defaultTemplate;
  return formatAddress(addressTemplate, address);
};
